import { Component, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition, stagger, query } from '@angular/animations';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  animations: [
    trigger('bannerTrigger', [
      transition(":enter", [
        query("*", [
          style({ opacity: 0, transform: "translateX(-50px)" }),
          stagger(50, [
            animate(
              "250ms cubic-bezier(0.35, 0, 0.25, 1)",
              style({ opacity: 1, transform: "none" })
            )
          ])
        ])
      ])
    ])
  ]
})
export class BannerComponent implements OnInit {
  pretitle = "Hello! I am";
  actionBtn = "Get in touch";
  bannerDescription: string;

  constructor() { }

  ngOnInit(): void {
    this.updateBannerDescription();
  }

  updateBannerDescription(): void {
    const experienceDuration = this.calculateExperienceDuration();
    this.bannerDescription = `I have <span class='underline'>${experienceDuration}</span> in building robust and efficient web applications. Developing User interfaces, and technological solutions to make the web a better place. I focus on writing and refactoring clean, reusable, and scalable code in <span class='underline'>Angular, </span> <span class='underline'>React.js </span> and <span class='underline'>Node.js </span>, applying good practices and development standards.`;
  }

  calculateExperienceDuration(): string {
    const startDate = new Date(2023, 2); // March 2023
    const currentDate = new Date();
  
    const startYear = startDate.getFullYear();
    const startMonth = startDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
  
    let years = currentYear - startYear;
    let months = currentMonth - startMonth;
  
    if (months < 0) {
      years--;
      months += 12;
    }
  
    const totalYears = years + months / 12;
    return totalYears.toFixed(1) + ' years';
  }
}
